import * as React from 'react';
import cn from 'classnames';

import * as styles from './styles.css';
import { useIsMobileDevice } from '../../../../hooks';
import { Header1, Header2 } from '@cian/ui-kit/typography/Header';

export interface IBannerProps {
  title: string;
  text: string | React.ReactNode;
  button: React.ReactNode;
  image: React.ReactNode;
  isUpMobileImg?: boolean;
  hasGradientBorder?: boolean;
}

export const Banner: React.FC<IBannerProps> = ({ title, text, button, hasGradientBorder, isUpMobileImg, image }) => {
  const isMobile = useIsMobileDevice();

  const Header = isMobile ? Header2 : Header1;

  return (
    <div
      className={cn(
        styles['wrapper'],
        hasGradientBorder && styles['gradient-border'],
        hasGradientBorder && isMobile && styles['gradient-border-mobile'],
        isMobile && styles['wrapper-mobile'],
      )}
    >
      <div
        className={cn(
          styles['content'],
          isUpMobileImg && isMobile && styles['content-down'],
          isMobile && styles['content-mobile'],
        )}
      >
        <div className={cn(styles['title'], isMobile && styles['title-mobile'])}>
          <Header>{title}</Header>
        </div>
        <p className={cn(styles['text'], isMobile && styles['text-mobile'])}>{text}</p>
        {button}
      </div>
      {image}
    </div>
  );
};
